import { useEffect, useState, useMemo } from "react";
import {
  swalSuccess,
  swalError,
  swalConfirm,
} from "../../../utils/swalAlert.js";
import "../../../styles/AdminPanel/userList.css";
import EditModal from "../components/EditModal.jsx";

import {
  getUsers,
  toggleUserActive,
  updateUser,
} from "../../../api/admin/userManager";
/* ================================== DATE FORMAT ================================== */ function formatJalali(
  dateString,
) {
  if (!dateString) return "---";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "---";
  const datePart = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
  const timePart = new Intl.DateTimeFormat("fa-IR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(date);
  return `${datePart} - ${timePart}`;
}
/* ==================================== ICONS ====================================== */ function PaperclipIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="17"
      height="17"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {" "}
      <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.82-2.82l8.49-8.48" />{" "}
    </svg>
  );
}
function PencilIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="17"
      height="17"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {" "}
      <path d="M12 20h9" />{" "}
      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L8 18l-4 1 1-4Z" />{" "}
    </svg>
  );
}
function PowerIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="17"
      height="17"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {" "}
      <path d="M12 2v10" /> <path d="M18.36 6.64a9 9 0 1 1-12.73 0" />{" "}
    </svg>
  );
}
function ChevronRightIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {" "}
      <path d="M15 6l-6 6 6 6" />{" "}
    </svg>
  );
}
function ChevronLeftIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {" "}
      <path d="M9 6l6 6-6 6" />{" "}
    </svg>
  );
}
function UserDisableIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="17"
      height="17"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {" "}
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />{" "}
      <circle cx="9" cy="7" r="4" /> <path d="m17 8 4 4" />{" "}
      <path d="m21 8-4 4" />{" "}
    </svg>
  );
}
function UserEnableIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="17"
      height="17"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {" "}
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />{" "}
      <circle cx="9" cy="7" r="4" /> <path d="m16 11 2 2 4-4" />{" "}
    </svg>
  );
}

/* ========================================================= ATTACHMENT MODAL ========================================================= */ function AttachmentModal({
  user,
  onClose,
}) {
  if (!user) return null;
  const hasCard = !!user.national_card_image;
  const hasLetter = !!user.commitment_letter_image;
  const hasAny = hasCard || hasLetter;
  const userName =
    user.first_name || user.last_name
      ? `${user.first_name || ""} ${user.last_name || ""}`.trim()
      : user.phone_number;
  return (
    <div className="attachment-overlay" onClick={onClose}>
      {" "}
      <div
        className="attachment-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="پیوست‌های کاربر"
      >
        {" "}
        <button
          type="button"
          className="attachment-close"
          onClick={onClose}
          aria-label="بستن"
          title="بستن"
        >
          {" "}
          ×{" "}
        </button>{" "}
        <div className="attachment-header">
          {" "}
          <div className="attachment-header-icon">
            {" "}
            <PaperclipIcon />{" "}
          </div>{" "}
          <div>
            {" "}
            <h3 className="attachment-title">پیوست‌های کاربر</h3>{" "}
            <p className="attachment-user-name">{userName}</p>{" "}
          </div>{" "}
        </div>{" "}
        {!hasAny ? (
          <div className="attachment-empty-box">
            {" "}
            <div className="attachment-empty-icon">
              {" "}
              <PaperclipIcon />{" "}
            </div>{" "}
            <p>مدرکی برای این کاربر بارگذاری نشده است.</p>{" "}
          </div>
        ) : (
          <div className="attachment-grid">
            {" "}
            {/* کارت ملی */}{" "}
            <div className="attachment-item attachment-item-width">
              {" "}
              <div className="attachment-item-icon">
                {" "}
                <PaperclipIcon />{" "}
              </div>{" "}
              <div className="attachment-item-content">
                {" "}
                <p className="attachment-label">تصویر کارت ملی</p>{" "}
                {hasCard ? (
                  <a
                    href={user.national_card_image}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="attachment-link"
                  >
                    {" "}
                    مشاهده مدرک{" "}
                  </a>
                ) : (
                  <div className="attachment-empty">پیوست نشده</div>
                )}{" "}
              </div>{" "}
            </div>{" "}
            {/* تعهدنامه */}{" "}
            <div className="attachment-item attachment-item-width">
              {" "}
              <div className="attachment-item-icon">
                {" "}
                <PaperclipIcon />{" "}
              </div>{" "}
              <div className="attachment-item-content">
                {" "}
                <p className="attachment-label">تصویر تعهدنامه</p>{" "}
                {hasLetter ? (
                  <a
                    href={user.commitment_letter_image}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="attachment-link"
                  >
                    {" "}
                    مشاهده مدرک{" "}
                  </a>
                ) : (
                  <div className="attachment-empty">پیوست نشده</div>
                )}{" "}
              </div>{" "}
            </div>{" "}
          </div>
        )}{" "}
      </div>{" "}
    </div>
  );
}
/* ========================================================= ATTACHMENT BUTTON ========================================================= */ function AttachmentIcon({
  user,
  onClick,
}) {
  const hasCard = !!user.national_card_image;
  const hasLetter = !!user.commitment_letter_image;
  const hasAny = hasCard || hasLetter;
  const hasAll = hasCard && hasLetter;
  return (
    <button
      type="button"
      className={`btn-attachment ${hasAll ? "has-all" : hasAny ? "has-some" : "has-none"}`}
      onClick={onClick}
      title={
        hasAll
          ? "مشاهده پیوست‌ها — ۲ مدرک"
          : hasAny
            ? "مشاهده پیوست‌ها — ۱ مدرک"
            : "مشاهده پیوست‌ها — بدون مدرک"
      }
      aria-label="مشاهده پیوست‌های کاربر"
    >
      {" "}
      <PaperclipIcon />{" "}
      {hasAny && (
        <span className="attachment-badge"> {hasAll ? "2" : "1"} </span>
      )}{" "}
    </button>
  );
}
/* ========================================================= USER LIST ========================================================= */ export default function UserList() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [attachmentUser, setAttachmentUser] = useState(null);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    role: "",
    is_active: false,
  });
  const [allUsers, setAllUsers] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [roleFilter, setRoleFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 15;
  /* ========================================================= EDIT ========================================================= */ const openEditModal =
    (user) => {
      setEditingUser(user);
      setFormData({
        first_name: user.first_name || "",
        last_name: user.last_name || "",
        phone_number: user.phone_number || "",
        role: user.role || "support",
        is_active: user.is_active || false,
      });
      setIsModalOpen(true);
    };
  const closeModal = () => {
    setIsModalOpen(false);
    setEditingUser(null);
  };
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleSave = async () => {
    try {
      await updateUser(editingUser.id, formData);
      setAllUsers((prev) =>
        prev.map((u) => (u.id === editingUser.id ? { ...u, ...formData } : u)),
      );
      swalSuccess({ title: "با موفقیت ذخیره شد" });
      closeModal();
    } catch {
      swalError({ title: "خطا در ذخیره اطلاعات" });
    }
  };
  /* ========================================================= SEARCH ========================================================= */ const normalizeNumber =
    (value) => {
      if (!value) return "";
      return value
        .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
        .replace(/[^\d]/g, "");
    };
  /* ========================================================= FETCH ========================================================= */ useEffect(() => {
    fetchUsers();
  }, []);
  useEffect(() => {
    filterUsers();
  }, [roleFilter, search, allUsers, page]);
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await getUsers();
      const filtered = (res || []).filter((u) => u.role !== "admin");
      setAllUsers(filtered);
      setUsers(filtered);
    } catch {
      setError("خطا در دریافت لیست کاربران");
    } finally {
      setLoading(false);
    }
  };
  /* ========================================================= FILTER ========================================================= */ const filterUsers =
    () => {
      let filtered = [...allUsers];
      if (roleFilter !== "all") {
        filtered = filtered.filter((u) => u.role === roleFilter);
      }
      if (search.trim() !== "") {
        const normalizedSearch = normalizeNumber(search);
        filtered = filtered.filter((u) =>
          normalizeNumber(u.phone_number).includes(normalizedSearch),
        );
      }
      const start = (page - 1) * pageSize;
      setUsers(filtered.slice(start, start + pageSize));
    };
  const totalFilteredCount = allUsers.filter((u) => {
    if (roleFilter !== "all" && u.role !== roleFilter) {
      return false;
    }
    if (search.trim() !== "") {
      const normalizedSearch = normalizeNumber(search);
      if (!normalizeNumber(u.phone_number).includes(normalizedSearch)) {
        return false;
      }
    }
    return true;
  }).length;
  const totalPages = Math.ceil(totalFilteredCount / pageSize) || 1;
  const pageSafe = Math.min(page, totalPages);
  const pageNumbers = useMemo(() => {
    const nums = [];
    for (let n = 1; n <= totalPages; n++) nums.push(n);
    return nums;
  }, [totalPages]);
  /* ========================================================= STATUS ========================================================= */ const toggleStatus =
    async (user) => {
      const confirmed = await swalConfirm({
        title: "آیا مطمئن هستید؟",
        text: user.is_active ? "کاربر غیرفعال می‌شود" : "کاربر فعال می‌شود",
        confirmText: "بله",
        cancelText: "لغو",
        danger: user.is_active,
      });
      if (!confirmed) return;
      try {
        const res = await toggleUserActive(user.id);
        setAllUsers((prev) =>
          prev.map((u) =>
            u.id === user.id ? { ...u, is_active: res.data.is_active } : u,
          ),
        );
        swalSuccess({ title: "انجام شد" });
      } catch {
        swalError({ title: "خطا در انجام عملیات" });
      }
    };
  /* ========================================================= ROLE ========================================================= */ const roleLabel =
    (role) => {
      const map = {
        support: "پشتیبان" /*, marketer: "بازاریاب"*/,
        user: "کاربر",
      };
      return map[role] || role;
    };
  /* ========================================================= RENDER ========================================================= */ return (
    <>
      {" "}
      <h2 className="page-title">مدیریت کاربران</h2>{" "}
      {/* ===================================================== FILTERS ===================================================== */}{" "}
      <div className="filters">
        {" "}
        {[
          { key: "all", label: "همه کاربران" },
          { key: "support", label: "پشتیبان‌ها" },
          // { key: "marketer", label: "بازاریاب‌ها" },
          { key: "user", label: "کاربران عادی" },
        ].map(({ key, label }) => (
          <button
            type="button"
            key={key}
            className={roleFilter === key ? "btn-active" : ""}
            onClick={() => {
              setPage(1);
              setRoleFilter(key);
            }}
          >
            {" "}
            {label}{" "}
          </button>
        ))}{" "}
        <input
          className="search-input"
          type="text"
          inputMode="numeric"
          placeholder="جستجوی شماره موبایل..."
          value={search}
          onChange={(e) => {
            setPage(1);
            setSearch(e.target.value);
          }}
        />{" "}
      </div>{" "}
      {/* ===================================================== TABLE ===================================================== */}{" "}
      <div className="table-wrapper">
        {" "}
        <table className="user-table">
          {" "}
          <thead>
            {" "}
            <tr>
              {" "}
              <th>#</th> <th>شماره موبایل</th> <th>نام</th> <th>کد ملی</th>{" "}
              <th>نقش</th> <th>وضعیت</th> <th>تاریخ ساخت</th> <th>پیوست</th>{" "}
              <th>عملیات</th>{" "}
            </tr>{" "}
          </thead>{" "}
          <tbody>
            {" "}
            {loading ? (
              <tr>
                {" "}
                <td colSpan={9} className="table-message">
                  {" "}
                  در حال بارگذاری...{" "}
                </td>{" "}
              </tr>
            ) : users.length === 0 ? (
              <tr>
                {" "}
                <td colSpan={9} className="table-message">
                  {" "}
                  هیچ نتیجه‌ای یافت نشد{" "}
                </td>{" "}
              </tr>
            ) : (
              users.map((user, index) => (
                <tr key={user.id}>
                  {" "}
                  <td className="row-number">
                    {" "}
                    {index + 1 + (page - 1) * pageSize}{" "}
                  </td>{" "}
                  <td className="phone-cell"> {user.phone_number} </td>{" "}
                  <td>
                    {" "}
                    {user.first_name || user.last_name
                      ? `${user.first_name || ""} ${user.last_name || ""}`.trim()
                      : "---"}{" "}
                  </td>{" "}
                  <td> {user.national_code || "---"} </td>{" "}
                  <td>
                    {" "}
                    <span className={`role-badge role-${user.role}`}>
                      {" "}
                      {roleLabel(user.role)}{" "}
                    </span>{" "}
                  </td>{" "}
                  <td>
                    {" "}
                    <span
                      className={`status-badge ${user.is_active ? "status-active" : "status-inactive"}`}
                    >
                      {" "}
                      <span /> {user.is_active ? "فعال" : "غیرفعال"}{" "}
                    </span>{" "}
                  </td>{" "}
                  <td className="date-cell">
                    {" "}
                    {formatJalali(user.created_at)}{" "}
                  </td>{" "}
                  <td>
                    {" "}
                    <AttachmentIcon
                      user={user}
                      onClick={() => setAttachmentUser(user)}
                    />{" "}
                  </td>{" "}
                  <td>
                    {" "}
                    <div className="user-actions">
                      {" "}
                      <button
                        type="button"
                        className={`action-icon-btn ${user.is_active ? "action-disable" : "action-enable"}`}
                        onClick={() => toggleStatus(user)}
                        title={
                          user.is_active
                            ? "غیرفعال کردن کاربر"
                            : "فعال کردن کاربر"
                        }
                        aria-label={
                          user.is_active
                            ? "غیرفعال کردن کاربر"
                            : "فعال کردن کاربر"
                        }
                      >
                        {" "}
                        {user.is_active ? (
                          <UserDisableIcon />
                        ) : (
                          <UserEnableIcon />
                        )}{" "}
                      </button>{" "}
                      <button
                        type="button"
                        className="action-icon-btn action-edit"
                        onClick={() => openEditModal(user)}
                        title="ویرایش کاربر"
                        aria-label="ویرایش کاربر"
                      >
                        {" "}
                        <PencilIcon />{" "}
                      </button>{" "}
                    </div>{" "}
                  </td>{" "}
                </tr>
              ))
            )}{" "}
          </tbody>{" "}
        </table>{" "}
        {/* ===================================================== PAGINATION ===================================================== */}
        {totalFilteredCount > 0 && (
          <div className="orders-pagination">
            <span className="pagination-info">
              {totalFilteredCount.toLocaleString("fa-IR")} کاربر — صفحه{" "}
              {pageSafe.toLocaleString("fa-IR")} از{" "}
              {totalPages.toLocaleString("fa-IR")}
            </span>
            <div className="pagination-controls">
              <button
                type="button"
                className="page-btn"
                disabled={pageSafe === 1}
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                aria-label="صفحه قبل"
              >
                <ChevronRightIcon />
              </button>
              {pageNumbers.map((n) => (
                <button
                  type="button"
                  key={n}
                  className={`page-btn number${n === pageSafe ? " active" : ""}`}
                  onClick={() => setPage(n)}
                >
                  {n.toLocaleString("fa-IR")}
                </button>
              ))}
              <button
                type="button"
                className="page-btn"
                disabled={pageSafe === totalPages}
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                aria-label="صفحه بعد"
              >
                <ChevronLeftIcon />
              </button>
            </div>
          </div>
        )}
      </div>{" "}
      {/* ===================================================== EDIT MODAL ===================================================== */}{" "}
      {isModalOpen && (
        <EditModal onClose={closeModal}>
          {" "}
          <div className="edit-user-form">
            {" "}
            <div className="edit-user-header">
              {" "}
              <h3>ویرایش کاربر</h3>{" "}
              <p> اطلاعات کاربر را ویرایش و ذخیره کنید. </p>{" "}
            </div>{" "}
            <div className="edit-user-grid">
              {" "}
              <label>
                {" "}
                <span>نام</span>{" "}
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleInputChange}
                />{" "}
              </label>{" "}
              <label>
                {" "}
                <span>نام خانوادگی</span>{" "}
                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleInputChange}
                />{" "}
              </label>{" "}
              <label>
                {" "}
                <span>شماره موبایل</span>{" "}
                <input
                  type="text"
                  name="phone_number"
                  value={formData.phone_number}
                  onChange={handleInputChange}
                />{" "}
              </label>{" "}
              <label>
                {" "}
                <span>نقش</span>{" "}
                <select
                  name="role"
                  value={formData.role}
                  onChange={handleInputChange}
                >
                  {" "}
                  <option value="support"> پشتیبان </option>{" "}
                  {/* <option value="marketer"> بازاریاب </option>{" "} */}
                  <option value="user"> کاربر معمولی </option>{" "}
                </select>{" "}
              </label>{" "}
              <label className="active-toggle">
                {" "}
                <span>وضعیت کاربر</span>{" "}
                <div className="checkbox-wrapper">
                  {" "}
                  <input
                    type="checkbox"
                    name="is_active"
                    checked={formData.is_active}
                    onChange={handleInputChange}
                  />{" "}
                  <span> {formData.is_active ? "فعال" : "غیرفعال"} </span>{" "}
                </div>{" "}
              </label>{" "}
            </div>{" "}
            <div className="modal-buttons">
              {" "}
              <button
                type="button"
                className="btn btn-save"
                onClick={handleSave}
              >
                {" "}
                ذخیره تغییرات{" "}
              </button>{" "}
              <button
                type="button"
                className="btn btn-cancel"
                onClick={closeModal}
              >
                {" "}
                انصراف{" "}
              </button>{" "}
            </div>{" "}
          </div>{" "}
        </EditModal>
      )}{" "}
      {/* ===================================================== ATTACHMENT MODAL ===================================================== */}{" "}
      {attachmentUser && (
        <AttachmentModal
          user={attachmentUser}
          onClose={() => setAttachmentUser(null)}
        />
      )}{" "}
      {/* ===================================================== ERROR ===================================================== */}{" "}
      {error && (
        <FullPageOverlay message={error} onClose={() => setError(null)} />
      )}{" "}
    </>
  );
}
